import { createRouter, createWebHashHistory } from 'vue-router'
import setupGuard from './guard'
import notFoundRoutes from './modules/404'
import shareRoutes from './modules/share'
import signupRoutes from './modules/signup'
import invitationRecordRoutes from './modules/invitationRecord'
import infoDetailRoutes from './modules/infoDetail'
import downloadRoutes from './modules/download'

export const routes = [
  ...shareRoutes,
  ...signupRoutes,
  ...invitationRecordRoutes,
  ...infoDetailRoutes,
  ...downloadRoutes,
  ...notFoundRoutes,
  {
    path: '/:catchAll(.*)',
    redirect: '/404',
    meta: {}
  }
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

setupGuard(router)

export default router
